export default __webpack_public_path__ + "static/media/icon-instagram.eabc5274.svg";